import cookies from 'js-cookie'

const getCookieValue = (name) => {
    if(name === undefined) return null
    try {
        let apiAccessString = cookies.get(name)
        if(typeof apiAccessString === 'string') {
            apiAccessString = apiAccessString.replace(/(s:j:)/g, '')
            apiAccessString = apiAccessString.replace(/(\}\.).*/g, '}')
            apiAccessString = apiAccessString = JSON.parse(apiAccessString)
            Object.assign(apiAccessString, {name: name})
        }
        return apiAccessString
    } catch (error) {
        return error
    }
}

let actions = {
    _storeApiAccess: (apiAccessObjects)=>{
		return {
                    type: 'API_ACCESS__UPDATE',
                    payload: apiAccessObjects
                }
    },
    _removeApiAccess: (name)=>{
        return {
                    type: 'API_ACCESS__REMOVE',
                    payload: name
                }
    },
    _error: (errorObject)=>{
		return {
                    type: 'API_ACCESS__ERROR',
                    payload: errorObject
                }
    },
    readApiAccess: ()=>{
        const apiAccessNames = ['ivarwebapi']

        const apiAccessObjects = apiAccessNames.map(name=>getCookieValue(name)).filter(elem=>elem != null) // getCookieValue for each known api. Filter out values of null and undefined.
        return (dispatch)=>{
            if(apiAccessObjects instanceof Error) dispatch(actions._error(apiAccessObjects))
            else dispatch(actions._storeApiAccess(apiAccessObjects))
        }
    },
    removeApiAccess: (name) => {
        return (dispatch)=>{
            dispatch(actions._removeApiAccess(name))
            return dispatch(actions.readApiAccess())
        }
    }
}

export default actions